import script from "./form_wizard.vue?vue&type=script&setup=true&lang=js"
export * from "./form_wizard.vue?vue&type=script&setup=true&lang=js"

import "./form_wizard.vue?vue&type=style&index=0&id=5090b394&lang=scss"

const __exports__ = script;

export default __exports__